import React from "react";
import { observer } from "mobx-react";
import { Switch, Redirect, Route, withRouter } from "react-router-dom";
import Inbox from "../ConnectInbox/Inbox";
import LinkedInAccounts from "../ConnectedAccounts/LinkedInAccounts/main";
import { userDetail } from "Stores/userDetail";
import WhatsAppAccounts from "../ConnectedAccounts/WhatsAppAccounts/main";

import InboxSequences from "../ConnectedAccounts/ConnectedInboxesSequences";

const CrmRouting = observer((props = {}) => {
  return (
    <Switch>
      <Route
        exact
        path="/settings/account/email"
        render={() => <Inbox {...props} />}
      />
      {!userDetail?.featuresDisabled.includes("LINKEDIN_AUTOMATION") && (
        <Route
          exact
          path="/settings/account/linkedin"
          render={() => <LinkedInAccounts {...props} />}
        />
      )}
      {!userDetail?.featuresDisabled.includes("WHATSAPP") && (
      <Route
        exact
        path="/settings/account/whatsapp"
        render={() => <WhatsAppAccounts {...props} />}
      />
      )}
      <Route
        exact
        path="/settings/account/sequences"
        render={() => <InboxSequences {...props} />}
      />
      <Redirect from="/settings/account" to="/settings/account/email" />
    </Switch>
  );
});

export default withRouter(CrmRouting);
